import { handleOnConnect, handleHMR } from '../virtusa-redux'
import { initThemeReducer, clearTheme } from '../themes'

const reducerKey = 'libraryRedux'

export const formStatusNone = ''
export const formStatusSuccess = 'success'
export const formStatusError = 'error'

// Define the redux initial state at the reducer key
const initialState = {
  formStatus: formStatusNone,
}

let { setState, getState } = handleHMR(module, initialState)

export const initLibraryRedux = store => {
  ({ setState, getState } = handleOnConnect(store, { reducerKey, initialState }))
  initThemeReducer(store)
}

// TODO: Call this when logging out.
export const clearLibraryRedux = () => {
  setState(initialState)
  clearTheme()
}

export const clearFormStatus = () =>
  setState({ formStatus: formStatusNone })

export const setFormStatusSuccess = () =>
  setState({ formStatus: formStatusSuccess })

export const setFormStatusError = () =>
  setState({ formStatus: formStatusError })

export const formStatusSelector = () =>
  getState().formStatus
